export enum FeedTypes {
  Quiz = "offence_quiz",
  LastReportedOffence = "last_reported_offence",
  SocialCommunity = "feed_social_community",
  OffenceReport = "offence_report",
  OffenceDetail = "offence_details",
  LatLngOffenceReport = "location_based_offence_report",
  CategoriesOffenceReport = "categories_offence_report",
  Banner = "banner",
  DiscoverQuiz = "discover_quiz",
  DiscoverQuizBanner = "discover_quiz_banner",
  TrendingOffence = "trending_offence",
}

export enum LayoutTypes {
  Vertical = "vertical",
  Carousel = "carousel",
}

export enum MediaTypes {
  Image = 1,
  Video = 2,
  Audio = 3,
}

export enum StatusTypes {
  Pending = 2,
  Approved = 3,
  Rejected = 4,
}

export enum ReactionTypes {
  None = -1,
  Default = 0,
  Like = 1,
  Angry = 2,
  Laugh = 3,
  Salute = 4,
  HandShake = 5,
}

export const ReactionUrls = {
  [ReactionTypes.Like]: {
    img: "/app/content/img/offenceReporter/reactions/like.png",
    text: "Liked",
  },
  [ReactionTypes.Angry]: {
    img: "/app/content/img/offenceReporter/reactions/angry.png",
    text: "Angry",
  },
  [ReactionTypes.HandShake]: {
    img: "/app/content/img/offenceReporter/reactions/handshake.png",
    text: "Support",
  },
  [ReactionTypes.Laugh]: {
    img: "/app/content/img/offenceReporter/reactions/laugh.png",
    text: "Funny",
  },
  [ReactionTypes.Salute]: {
    img: "/app/content/img/offenceReporter/reactions/salute.png",
    text: "Safety warrior",
  },
};
